/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
    {
        path: "/login/:path?",
        name: "Login",
        view: "Login",
    },
    {
        path: "/messages",
        // Relative to /src/views
        view: "Messages",
        name: "Messages",
    },
    {
        path: "/messages-new",
        view: "MessagesNew",
        name: "MessagesNew",
    },
    {
        path: "/messages-mobile",
        // Relative to /src/views
        view: "MessagesMobile",
        name: "MessagesMobile",
    },
    {
        path: "/calls-mobile",
        // Relative to /src/views
        view: "CallsMobile",
        name: "CallsMobile",
    },
    {
        path: "/calls",
        name: "Calls",
        view: "Calls",
    },
    {
        path: "/p-calls",
        name: "PCalls",
        view: "PCalls",
    },
    {
        path: "/p-messages",
        name: "PMessages",
        view: "PMessages",
    },
    {
        path: "/wercberger-hotline-messages",
        name: "WercbergerHotlineMessages",
        view: "WercbergerHotlineMessages",
    },
    {
        path: "/wercberger-hotline-calls",
        name: "WercbergerHotlineCalls",
        view: "WercbergerHotlineCalls",
    },
    {
        path: "/interviews",
        name: "Interviews",
        view: "Interviews",
    },
    {
        path: "/talks",
        name: "Talks",
        view: "Talks",
    },
    {
        path: "/lemanyeidey",
        name: "LemanYeidey",
        view: "LemanYeidey",
    },
    {
        path: "/greetings",
        name: "Greetings",
        view: "Greetings",
    },
    {
        path: "/audio",
        name: "Audio",
        view: "Audio",
    },
    {
        path: "/questions",
        name: "Questions",
        view: "Questions",
    },
    {
        path: "/ai-cost-report",
        name: "AiCostReport",
        view: "AiCostReport",
    },
    {
        path: "/logs",
        name: "Logs",
        view: "Logs",
    },
    {
        path: "/kollel",
        name: "Kollel",
        view: "Kollel",
    },
    {
        path: "/recordings",
        name: "Recordings",
        view: "Recordings",
    },
    {
        path: "/photos",
        name: "Photos",
        view: "Photos",
    },
    {
        path: "/table-list",
        name: "Table List",
        view: "TableList",
    },
    {
        path: "/typography",
        view: "Typography",
    },
    {
        path: "/icons",
        view: "Icons",
    },
    {
        path: "/maps",
        view: "Maps",
    },
    {
        path: "/notifications",
        view: "Notifications",
    },
    {
        path: "/upgrade",
        name: "Upgrade to PRO",
        view: "Upgrade",
    },
];
